// Tiny translation layer. All UI text lives in ./en/<screen>.ts so a later
// localization only adds another folder. Usage: t('camp.planExpedition', { n: 3 })
import en from './en';

type Dict = { readonly [k: string]: string | Dict };
const dicts: Record<string, Dict> = { en: en as unknown as Dict };
let lang = 'en';

export function setLanguage(l: string) {
  if (dicts[l]) lang = l;
}

export function t(key: string, params?: Record<string, string | number>): string {
  let cur: string | Dict | undefined = dicts[lang];
  for (const part of key.split('.')) {
    if (!cur || typeof cur === 'string') return key;
    cur = cur[part];
  }
  if (typeof cur !== 'string') return key;
  if (!params) return cur;
  return cur.replace(/\{(\w+)\}/g, (_, k) => (params[k] !== undefined ? String(params[k]) : `{${k}}`));
}
